import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import EditableTextField from 'ui-library/inputs/EditableTextField';

export interface BarcodeValueProps {
  storable: {barcode?: string | null};
  isDisabled?: boolean;
  handleBarcodeChange?: (barcode: string) => void;
  confirmBeforeStartEditing?: () => Promise<boolean>;
  disableEditsWithTooltip?: string | null;
}
export default function BarcodeValue(props: BarcodeValueProps): JSX.Element {
  if (props.storable.barcode) {
    if (props.handleBarcodeChange) {
      return (
        <div className={css(styles.fullWidth)}>
          <EditableTextField
            isDisabled={props.isDisabled}
            emptyValueAllowed={false}
            requestChange={props.handleBarcodeChange}
            value={props.storable.barcode}
            confirmBeforeStartEditing={props.confirmBeforeStartEditing}
            disableEditsWithTooltip={props.disableEditsWithTooltip}
            dataTestAttrs={{component: 'Barcode', element: 'value'}}
            hasFieldActionButtonsOuterMargin={false}
          />
        </div>
      );
    }

    return <span {...getTestProps({component: 'Barcode', element: 'value'})}>{props.storable.barcode}</span>;
  }
  return <span className="u-faded">None</span>;
}

const styles = StyleSheet.create({
  fullWidth: {
    maxWidth: '90%',
  },
});
